import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PetsIcon from '@mui/icons-material/Pets';
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { BottomNav, type NavItem } from '@paneon/ui';

const navItems: NavItem[] = [
  {
    path: '/',
    label: 'Dashboard',
    icon: <HomeOutlinedIcon />,
    activeIcon: <HomeIcon />,
  },
  {
    path: '/pets',
    label: 'Haustiere',
    icon: <PetsOutlinedIcon />,
    activeIcon: <PetsIcon />,
  },
  {
    path: '/feed',
    label: 'Fütterung',
    icon: <RestaurantOutlinedIcon />,
    activeIcon: <RestaurantIcon />,
  },
  {
    path: '/settings',
    label: 'Einstellungen',
    icon: <SettingsOutlinedIcon />,
    activeIcon: <SettingsIcon />,
  },
];

/**
 * Main app layout with bottom navigation
 */
export function AppLayout() {
  return (
    <Box sx={{ minHeight: '100vh' }}>
      {/* Page content */}
      <Outlet />

      {/* Bottom navigation */}
      <BottomNav items={navItems} />
    </Box>
  );
}
